import React, { useState } from "react";
import Img from "gatsby-image";
import Fade from "react-reveal/Fade";
import { Link } from "gatsby";
import StyledHero from "../../../styled-components/Header/StyledHero";

import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Hero = ({ data }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    timeToCall: "",
  });

  const [disabled, setDisabled] = useState(false);

  const { name, email, phone, timeToCall } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    // const url = "http://localhost:5000/hbh-firebase/us-central1/api";
    const url = "https://us-central1-hbh-firebase.cloudfunctions.net/api";

    console.log("log");
    if (disabled) {
      toast.info("Form already submitted!");
    } else if (Object.values(formData).includes("")) {
      toast.info("Please fill out all fields");
    } else {
      setDisabled(true);

      axios.post(`${url}/contact/contactADU1`, formData).then(() => {
        toast.success("Info submitted!");
        setFormData({ name: "", email: "", phone: "", timeToCall: "" });
      });
    }
  };

  return (
    <section style={{ background: "white" }}>
      <StyledHero>
        <div className='hero'>
          <Img className='heroImage' alt={data.title} fluid={data.fluid} />
          <div className='heroWrapper'>
            <div className='contactHero-container'>
              <div className='container-item-1 container-item'>
                <h1>Lets talk about ADUs!</h1>
                <TextField disabled={disabled} name='name' value={name} onChange={onChange} label='Name' variant='standard' />
                <TextField disabled={disabled} name='email' value={email} onChange={onChange} label='Email' variant='standard' />
                <TextField disabled={disabled} name='phone' value={phone} onChange={onChange} label='Phone' variant='standard' />
                <FormControl>
                  <FormLabel id='demo-row-radio-buttons-group-label'> Best time to call?</FormLabel>
                  <RadioGroup
                    disabled={disabled}
                    value={timeToCall}
                    onChange={onChange}
                    name='timeToCall'
                    row
                    aria-labelledby='demo-row-radio-buttons-group-label'
                  >
                    <FormControlLabel value='ASAP' control={<Radio />} label='ASAP' />
                    <FormControlLabel value='Today' control={<Radio />} label='Today' />
                    <FormControlLabel value='Tomorrow' control={<Radio />} label='Tomorrow' />
                  </RadioGroup>
                </FormControl>
                <button
                  onClick={() => {
                    onSubmit();
                  }}
                  className='cta cta-main'
                  style={{ padding: "1rem 4rem", fontSize: "20px", margin: "1rem auto" }}
                >
                  {disabled ? "Submitted!" : "Submit"}
                </button>

                {/* <Button variant='contained'>Contained</Button> */}
              </div>
              {typeof window !== "undefined" && window.innerWidth > 1000 && (
                <div className='container-item-2 container-item'>
                  <h1>Have Questions?</h1>
                  <h2>Call us:</h2>
                  <h2>(619) 807-0287</h2>
                  <h2>Email us:</h2>
                  <h2>RJ@myadustory.com</h2>
                </div>
              )}
            </div>
            {/* <button className='cta cta-main'> */}
            {/* <button className='cta cta-secondary'>
            <Link style={{ textDecoration: "none" }} to='/about'>
              What's an ADU?
            </Link>
          </button> */}
          </div>
        </div>
      </StyledHero>
      {typeof window !== "undefined" && window.innerWidth <= 1000 && (
        <div style={{ background: "white", margin: " 0 -2rem", padding: "4rem 0 2rem", position: "relative" }}>
          <Fade right delay={1500}>
            <div style={{ margin: "2rem 0" }} className='container-item-2 container-item'>
              <h1 style={{ fontWeight: "bold", fontSize: "36px", textAlign: "center" }}>Have Questions?</h1>
              <h2 style={{ textAlign: "center", fontSize: "18px" }}>Call us:</h2>
              <h2 style={{ textAlign: "center", fontSize: "18px" }}>(619) 807-0287</h2>
              <h2 style={{ textAlign: "center", fontSize: "18px" }}>Email us:</h2>
              <h2 style={{ textAlign: "center", fontSize: "18px" }}>RJ@myadustory.com</h2>
            </div>
          </Fade>
        </div>
      )}
      <ToastContainer delay={2000} />
    </section>
  );
};

export default Hero;
